import { Component, OnInit } from '@angular/core';
import { userDetails } from 'src/app/models/user.model';
import { MLSListingService } from 'src/services/mls-listings.service';
import { UserDetailService } from '../../../services/user-details.service';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.css']
})
export class OurTeamComponent implements OnInit {

  userDetails: userDetails[] = [];
  //adminDetails: userDetails[] = [];
  all_ids = [];
  all_agents_id = '';

  constructor(private UserDetailService: UserDetailService, private mlsService:MLSListingService) { }

  ngOnInit() {
    this.UserDetailService.getEveryone().subscribe(res => {
      // console.log((res as any).Users);
      this.userDetails = (res as any).Users;
      this.userDetails.sort((a,b) => a.full_name < b.full_name ? -1 : a.full_name > b.full_name ? 1: 0);
      // for(var i=0; i<this.userDetails.length; i++) {
      //   if(this.userDetails[i].agentMLS_ID) {
      //     this.all_agents_id = this.all_agents_id + '&agent=' + this.userDetails[i].agentMLS_ID;
      //   }
        
      // }
      // //console.log(this.all_agents_id);
      // this.mlsService.getStrideListings(this.all_agents_id).subscribe(res => {
      //   console.log(res);
      // })

      

    });


    // this.UserDetailService.getAdmins().subscribe(res => {
    //   console.log((res as any).Users);
    //   this.adminDetails = (res as any).Users;
    //   this.adminDetails.sort((a,b) => a.full_name < b.full_name ? -1 : a.full_name > b.full_name ? 1: 0);
    // });
  }


}
